import { BaseClient } from './BaseClient';
export class MarketplaceAPI extends BaseClient {
    async signWertMessage(message, identity) {
        try {
            const response = await this.fetch('/v1/wert/sign', {
                method: 'POST',
                identity,
                body: JSON.stringify(message),
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return response;
        }
        catch (error) {
            throw new Error(error.message);
        }
    }
}
//# sourceMappingURL=marketplaceApi.js.map